module.exports = __webpack_public_path__ + "static/media/image_85.162bcc4e.png";